import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p427286551862546432',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
